import { format } from "date-fns";
import {
  Component,
  OnInit,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  OnDestroy,
} from "@angular/core";
import { CallCenterService } from "src/app/services/call-center.service";
import { CommonService } from "src/app/services/common.service";
import { CommonMethods } from "src/app/shared/CommonMethods";
import { Subscription } from "rxjs";
import { AskApolloService } from "src/app/services/ask-apollo.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MessageServiceService } from "src/app/services/message-service.service";
import { AttachSession } from "protractor/built/driverProviders";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-call-back-later",
  templateUrl: "./call-back-later.component.html",
  styleUrls: ["./call-back-later.component.scss"],
  providers: [DatePipe],
})
export class CallBackLaterComponent implements OnInit, OnDestroy {
  callDropFormGroup: FormGroup;
  enquiryForm: FormGroup;
  formSubmitted: boolean = false;

  //@Input() formReset: boolean;

  //@Input() callerStatusAutoId: number;
  //@Input() selectedCallStatusId: any;

  //@Output() formSubmit = new EventEmitter<any>();

  selectedAppointmentType = 1;
  selectedHospitalType = 2;
  minDate: Date = new Date();
  yearRange = "";
  selectedTime: string;
  loadingFlag: boolean;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageServiceService,
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    private askApolloService: AskApolloService,
    private datePipe: DatePipe
  ) {
    let currentDate = new Date();
    this.yearRange = `${currentDate.getFullYear()}:${
      currentDate.getFullYear() + 10
    }`;

    // Formatting current time to "HH:mm"
    let currentTime = this.formatTime(currentDate);

    // Initializing Form with default values
    this.callDropFormGroup = this.fb.group({
      callbackDate: [currentDate, Validators.required], // Set default date
      callbackTime: ["", Validators.required], // Set default time
      remark: ["", Validators.required],
    });
  }

  ngOnInit() {
    this.initiateForm();
    // this.selectedTime = this.times[0];
  }

  // times: string[] = [
  //   '01:00' ,
  // ];

  ngOnDestroy() {
    //this.PackageEnquiryData.unsubscribe();
  }

  citiesData: any[];
  clinicsData: any[];

  ngOnChanges() {
    // if (this.formReset) {
    //   if (this.enquiryForm) this.resetForm();
    // }
  }

  initiateForm() {
    this.enquiryForm = this.fb.group({
      PatientName: ["", [Validators.required]],
      MobileNumber: ["", [Validators.required]],
    });
  }

  resetForm() {
    this.enquiryForm.reset();
    this.enquiryForm.get("callbacktime").setValue("");
  }

  getSubDispositionsOnId(event) {
    if (event == 35) {
      this.enquiryForm.get("EDD").enable();
    } else {
      this.enquiryForm.get("EDD").disable();
    }
  }

  formattedDate: string;

  //   dateConverter(datePipe: DatePipe)
  // {
  //   const date = new Date();
  //   this.formattedDate = this.datePipe.transform(date, 'yyyy-MM-dd');
  // }
  formatTime(date: Date): string {
    return this.datePipe.transform(date, "HH:mm") || "";
  }

  UpdateCallStatusDetails(formData) {
    if (this.callDropFormGroup.valid) {
      this.callDropFormGroup.enable();
      //   this.disableOrEnableForm(0);
      let formDataValues = this.callDropFormGroup.value;

      let leadData = JSON.parse(
        localStorage.getItem("CurrentOutBoundCallMobileNumber")
      );
      let callbackDate = this.datePipe.transform(
        formDataValues.callbackDate,
        "yyyy-MM-dd"
      );
      let callbackTime = this.datePipe.transform(
        formDataValues.callbackTime,
        "HH:mm"
      );
      let callbackDateTimeString = `${callbackDate}T${callbackTime}:00`;

      if (leadData == null || leadData == undefined) {
        const regex = /^\+91/;
        let leadData1 = JSON.parse(
          localStorage.getItem("CurrentInBoundCallDetails")
        );
        debugger;

        let payload = {
          callbackDateTime: callbackDateTimeString,
          leadId: 0,
          callsubstatus: 25,
          remark: formDataValues.remark,
          CallerNumber: leadData1.patientMobileNumber.replace(/^\+91/, ""),
          isActicityLead: false,
        };
        this.askApolloService.UpdateCallerStatus(payload).subscribe(
          (res: any) => {
            if (res && res != undefined) {
              this.messageService.showSuccess("Call Back later Status Updated");
              this.formSubmitted = true;
              //  this.syncCallHistory();
              this.callDropFormGroup.reset();
              this.commonService.setBooleanValue(false); // Set the value you want to share
            } else {
              this.messageService.showWarning("issue while updating the lead");
            }
            //this.disableOrEnableForm(1);
          },
          (error) => {
            this.messageService.showErrorMessage(
              "Unable to update call drop status, An error occur while updating status."
            );
            // this.disableOrEnableForm(1);
          }
        );
      } else {
        debugger;
        var IsActivity = localStorage.getItem("IsActivityLead");
        let payload = {
          callbackDateTime: callbackDateTimeString,
          leadId: leadData.leadId,
          callsubstatus: 25,
          remark: formDataValues.remark,
          CallerNumber: leadData.phoneNo,
          isActicityLead: IsActivity,
        };
        this.askApolloService.UpdateCallerStatus(payload).subscribe(
          (res: any) => {
            if (res && res != undefined) {
              setTimeout(() => {
                this.messageService.showSuccess("Call Back Status Updated");
              }, 200);
              this.formSubmitted = true;
              this.callDropFormGroup.reset();
              this.commonService.setBooleanValue(false); // Set the value you want to share
            } else {
              this.messageService.showWarning("issue while updating the lead");
            }
          },
          (error) => {
            this.messageService.showErrorMessage(
              "Unable to update call back status, An error occur while updating status."
            );
            this.disableOrEnableForm(1);
          }
        );
        this.disableOrEnableForm(1);
      }
    } else {
      this.messageService.showWarning("Please Fill Fields");
    }
    this.disableOrEnableForm(1);
  }

  disableOrEnableForm(flag) {
    // 1 enable , 0 disable
    if (flag == 1) {
      this.loadingFlag = false;
    } else {
      this.loadingFlag = true;
    }
  }
}
